module.exports = "<div class=\"container\">\r\n  <div ui-view></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/admin/admin.html
// module id = 682
// module chunks = 0